import React from "react";

export default function MenuAnimation() {
    return (
        <div className="header-animated-words">
            <div className="header-animated-words__word">
                <span>V</span>
                <span>E</span>
                <span>V</span>
                <span>O</span>
                <span>L</span>
            </div>

            <div className="header-animated-words__word">
                <span>M</span>
                <span>E</span>
                <span>D</span>
                <span>I</span>
                <span>A</span>
            </div>
        </div>
    );
}
